module.exports = __webpack_public_path__ + "img/text-program.32d5dd43.svg";